window.MAD_BRANDS = [
  { name: 'ADDICTED', origin: 'Spain · Barcelona', url: '/pages/addicted-brand-story' },
  { name: 'AQUX', origin: 'Japan', url: '/pages/aqux-brand-story' },
  { name: '2EROS', origin: 'Australia', url: '/pages/2eros-brand-story' },
  { name: 'B.V.D.', origin: 'Japan', url: '/pages/bvd-brand-story' },
  { name: 'EGDE', origin: 'Japan', url: '/pages/egde-brand-story' },
  { name: 'G-Station', origin: 'Japan', url: '/pages/g-station-brand-story' },
  { name: 'GX3 UNDERWEAR', origin: 'Japan', url: '/pages/gx3-brand-story' },
  { name: 'Hero Colors', origin: 'Japan', url: '/pages/hero-colors-brand-story' },
  { name: 'iSwim', origin: 'Taiwan', url: '/pages/iswim-brand-story' },
  { name: 'MARCUSE', origin: 'Australia', url: '/pages/marcuse-brand-story' },
  { name: 'pjur', origin: 'Germany', url: '/pages/pjur-brand-story' },
  { name: 'Private Structure', origin: 'Malaysia · Since 1999', url: '/pages/private-structure-brand-story' },
  { name: 'SPLASH', origin: 'Hong Kong', url: '/pages/splash-brand-story' },
  { name: 'Supawear', origin: 'Australia', url: '/pages/supawear-brand-story' },
  { name: 'SuperSlyde', origin: 'Singapore', url: '/pages/superslyde-brand-story' },
  { name: 'TENGA', origin: 'Japan', url: '/pages/tenga-brand-story' },
  { name: 'TM Collection', origin: 'Japan', url: '/pages/tm-collection-brand-story' },
  { name: 'TOOT', origin: 'Japan', url: '/pages/toot-brand-story' },
  { name: 'Tyler Bold', origin: 'Japan', url: '/pages/tyler-bold-brand-story' },
  { name: 'UNDERSTAND', origin: 'Japan', url: '/pages/understand-brand-story' }
];
